import {ReactNode} from "react";

interface PopUpProps {
  isOpen: boolean;
  onClose: () => void;
  children?: ReactNode;
  renderBody?: () => ReactNode;
  className?: string;
}

export default function Popup({isOpen, onClose, children, renderBody, className}: PopUpProps) {
  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <div className={`popup-box ${className ?? ""}`} onClick={(event) => event.stopPropagation()}>
        <button type="button" onClick={onClose} className="popup-close" aria-label="Close popup"> ✕ </button>
        <div className="popup-body">
          <div className="popup-scroll-box">
            {renderBody ? renderBody() : children}
          </div>
        </div>
      </div>
    </div>
  );
}


